import { AnswerData, ExtractedFieldData, FormMapperConfig, FormMapper } from './types';

export function detectCategoryGeneric(answersData: AnswerData[], config: FormMapperConfig): string | null {
  if (!answersData || answersData.length === 0) {
    return null;
  }

  const foundAnswer = answersData.find(answer => 
    Object.keys(config.patterns).some(pattern => 
      answer.questionTranslationKey.startsWith(pattern)
    )
  );

  if (foundAnswer) {
    const matchingPattern = Object.entries(config.patterns).find(([pattern]) =>
      foundAnswer.questionTranslationKey.startsWith(pattern)
    );
    return matchingPattern ? matchingPattern[1] : null;
  }

  return null;
}

export function extractFieldsGeneric(
  answersData: AnswerData[], 
  category: string, 
  config: FormMapperConfig
): ExtractedFieldData {
  if (!answersData || !category || !config.fieldConfigs[category]) {
    return {};
  }

  const requiredFields = config.fieldConfigs[category];
  const extractedData: ExtractedFieldData = {};

  answersData
    .filter(answer => requiredFields.includes(answer.questionTranslationKey))
    .forEach(answer => {
      const fieldLabel = config.displayLabels[answer.questionTranslationKey] || answer.questionTranslationKey;
      if (answer.answer && answer.answer.trim() !== '') {
        const fieldValue = answer.selectedOption?.translationKey || answer.answer;
        extractedData[fieldLabel] = fieldValue;
      }
    });

  return extractedData;
}

export function createFormMapper(config: FormMapperConfig): FormMapper {
  return {
    detectCategory: (answersData: AnswerData[]) => detectCategoryGeneric(answersData, config),
    
    extractFields: (answersData: AnswerData[], category: string) => 
      extractFieldsGeneric(answersData, category, config),
    
    getFieldLabel: (translationKey: string) => 
      config.displayLabels[translationKey] || translationKey,
    
    getTranslationKey: (translationKey: string) => 
      config.translationKeys[translationKey] || translationKey,
    
    getFieldsForCategory: (category: string) => 
      config.fieldConfigs[category] || []
  };
}
